import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Der Inhalt liegt jetzt unter der aelteren, bei Google bereits
 * rankenden Adresse /blog/shopify-checkout-optimieren.
 */
export const Route = createFileRoute("/ratgeber/shopify-checkout-optimieren")({
  beforeLoad: () => {
    throw redirect({ to: "/blog/shopify-checkout-optimieren", statusCode: 301 });
  },
  component: () => null,
});
